module.exports = __webpack_public_path__ + "img/border_edge_shape.71abfa06.svg";